import './index.scss'

import successIcon from 'url:@assets/icons/checkmark-circle.svg';

export default function SuccessView(props: {
  title: string,
  description: string
}) {
  return <div className='success-view-header'>
    <img src={successIcon} className='icon' alt={"Success"} />

    <h1>{props.title}</h1>
    <p>{props.description}</p>
  </div>
}